import { Col, message } from "antd";
import { Icons } from "../assets/icons";
import PageHeader from "../components/ui/PageHeader";
import { ICON_SIZE } from "../repository/data.default";
import FooterQuoteCard from "../components/ui/FooterQuoteCard";
import SatageSubHeader from "../components/ui/SatageSubHeader";
import SectionTwo from "../components/EvaluationReportingSections/SectionTwo";
import ViewReportCard from "../components/ui/ViewReportCard";

const footerText = (
  <p>
    Creating a wellbeing policy aligned with ISO 45003 and ESG (Environmental,
    Social, and Governance) regulations offers a strategic advantage by
    prioritizing psychological health alongside workplace safety. ISO 45003
    provides a structured framework to identify and manage psychosocial risks,
    while ESG principles emphasize the broader social responsibility of
    fostering a healthy, engaged workforce. This alignment not only enhances
    employee satisfaction and productivity but also strengthens an
    organization’s reputation with stakeholders and investors who increasingly
    value commitment to employee well-being. Moreover, businesses that adopt
    these standards often experience improved retention rates and reduced costs
    related to absenteeism, showcasing a direct link between wellbeing
    initiatives and long-term organizational success.
  </p>
);

const stepsList = (
  <>
    <li>a. Review Progress Report</li>
    <li>b. Review & Edit Well-Being Program Evaluation Report</li>
    <li>c. Create the well-being policy</li>
  </>
);

const overviewText = (
  <p>
    The Evaluation & Reporting Stage assesses the progress and effectiveness of
    well-being initiatives, identifies opportunities for improvement, and
    integrates findings into a structured final Well-Being Policy, aligned with
    ISO 45003 and ESG reporting standards. <br /> The Evaluation & Reporting
    stage is critical to measure the effectiveness of actions, identify
    successes, and determine next steps for improving workplace well-being
  </p>
);

function EvaluationReportingPage() {
  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      {/* Header */}
      <PageHeader
        stage={4}
        title={"Evaluation & Reporting"}
        icon={
          <Icons.PlanningActionsIcon width={ICON_SIZE} height={ICON_SIZE} />
        }
      />
      {/* Sub Header  */}
      <SatageSubHeader overviewText={overviewText} stepsList={stepsList} />

      {/* View Report */}
      <section className="flex justify-center">
        <ViewReportCard
          title="Progress Report"
          text="This report summarizes the progress of the well-being initiatives implemented. It evaluates key metrics, employee feedback, a.     work related incidents that compromise  workplace or employee wellbeing  and program participation to assess progress toward the organization’s well-being objectives."
          btnName="view report"
          btnAction={() =>
            message.info("This report is not yet available.")
          }
        />
        <ViewReportCard
          title="AUDITOR'S Report"
          text="NOTE: Consultant can only edit this report. "
          btnName="view report"
          btnAction={() =>
            message.info("This report is not yet available.")
          }
        />
      </section>

      {/* Steps Section */}
      <SectionTwo />

      {/* Footer */}
      <FooterQuoteCard
        icon={<Icons.EvaluationReportingIcon width={350} height={350} />}
        text={footerText}
      />
    </Col>
  );
}

export default EvaluationReportingPage;
